import { View, Platform, Pressable, Text, FlatList } from 'react-native';
import styles from '@stylesheet';
import React, { useMemo, useState, useRef, useEffect } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import SwipeableRobot, { RobotHandle } from '@components/RobotHelper/SwipeableRobot';
import { XStack } from 'tamagui';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getConnections, getProfile } from '@api/linkedInApi';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import AntDesign from '@expo/vector-icons/AntDesign';
import LoadingIndicator from '@components/Global/Spinner';

const SearchCompScreen = () => {
  const robotRef = useRef<RobotHandle>(null);
  const userAuths = useSelector((state: DefaultRootState) => state.promiseData.data.userData.authentications);
  const queryClient = useQueryClient();

  const linkedInAccessToken = userAuths['linkedin'] ? userAuths['linkedin'].access_token : null;

  console.log('linkedInAccessToken', linkedInAccessToken, userAuths);

  const [help, setHelp] = useState(true);

  const textHelp = useMemo(() => [
    'Easily find local businesses to help your business prosper',
    'Click on a company to view details',
    'Click on the eye to see more details on the map',
    'You can add your own companies to the map with a company account'
  ], []);

  useEffect(() => {
    return () => {
      queryClient.removeQueries({queryKey: ['linkedInConnections']})
      queryClient.removeQueries({ queryKey: ['linkedInProfile'] })
    }
  }, [])

  const getUserConnections = async () => {
    await getConnections(linkedInAccessToken)
  }

  const getLinkedInProfile = async () => {
    await getProfile(linkedInAccessToken)
  }

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['linkedInConnections'],
    queryFn: getUserConnections,
    retry: 2
  });

  const { data: profileData, isLoading: profileLoading, error, refetch: refetchProfile } = useQuery<any>({ queryKey: ['linkedInProfile'], queryFn: getLinkedInProfile });

  const renderItem = ({ item }) => {

    return (
      <Pressable style={{ padding: 10, borderBottomWidth: 1, borderBottomColor: '#ccc' }}>
        <Text style={{ fontSize: 16, fontWeight: 'bold' }}>{item.name}</Text>
        <Text style={{ fontSize: 14, color: '#555' }}>{item.headline}</Text>
      </Pressable>
    );
  }

  return (
    <DefaultScreen
      searchBar={{
        // callback: (value) => getSearchResults(value),
        customIcons: [
          {
            function: () => refetch(),
            icon: <AntDesign name="linkedin-square" size={20} color="white" />,
            functionName: 'LinkedIn'
          }
        ],
      }} scrollDisabled style={{ minWidth: "100%", paddingBottom: 50 }} containerStyle={{ paddingRight: 0, paddingBottom: 50 }}>
      <View style={[styles.pageContainer, { gap: 20, left: -10, flex: 1, alignSelf: 'stretch', borderRadius: 20, flexDirection: 'row', padding: 20 }]}>
        {
          profileData &&
          <>
            {
              profileLoading ?
                <LoadingIndicator type={undefined} color={undefined} />
                :
                <View style={{ flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>{profileData?.localizedFirstName} {profileData?.localizedLastName}</Text>
                  <Text style={{ fontSize: 16, color: '#555' }}>{profileData?.headline}</Text>
                  <Text style={{ fontSize: 14, color: '#777' }}>{profileData?.location?.name}</Text>
                </View>
            }
          </>
        }
        <FlatList data={data} renderItem={renderItem} />
      </View >
      <View style={{ position: "absolute", bottom: 0 }}>
        <SwipeableRobot ref={robotRef} textHelp={textHelp} />
      </View>
    </DefaultScreen>
  )
}
export default SearchCompScreen;
